import { render, staticRenderFns } from "./GalleryThumbnails.vue?vue&type=template&id=0990b5dc&scoped=true"
import script from "./GalleryThumbnails.vue?vue&type=script&lang=js"
export * from "./GalleryThumbnails.vue?vue&type=script&lang=js"
import style0 from "./GalleryThumbnails.vue?vue&type=style&index=0&id=0990b5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990b5dc",
  null
  
)

export default component.exports